






















import { debounce } from 'lodash';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';

import UiSelect2 from '../../components/ui/UiSelect2.vue';
import UiTextEdit from '../../components/ui/UiTextEdit.vue';

@Component({
  components: {
    UiTextEdit,
    UiSelect2,
  },
})
export default class BlockchainAddressInput extends BaseVue {
  public apiKey = '';
  public apiSecret = '';
  public exchangeContactId = '';
  public isValid = false;

  public debouncedValidate = debounce(this.validateForm.bind(this), 1000);

  public async validateForm() {
    this.isValid = !!this.apiKey && !!this.apiSecret && !!this.exchangeContactId;
  }

  public get contacts() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    const res: any = {};
    contacts.forEach((contact: any) => (res[contact.name] = contact.id));
    return res;
  }

  public get contactsArray() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    return contacts.map((contact: any) => ({ id: contact.id, label: contact.name }));
  }

  @Watch('apiKey')
  @Watch('apiSecret')
  @Watch('exchangeContactId')
  public onWalletTypeChanged() {
    this.debouncedValidate();
    this.$emit('data', {
      createBitfinex: {
        apiKey: this.apiKey,
        apiSecret: this.apiSecret,
        exchangeContactId: this.exchangeContactId,
      },
    });
  }

  @Watch('isValid')
  public validChanged() {
    this.$emit('valid', this.isValid);
  }
}
